import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { useUntypedTranslation } from '../../hooks/useUntypedTranslation';

const Footer: React.FC = () => {
  // Use our untyped translation hook to bypass TypeScript errors
  const { t } = useUntypedTranslation();

  const currentYear = new Date().toLocaleString('en-US', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
  });

  return (
    <Box
      component="footer"
      sx={theme => ({
        backgroundColor: theme.colors.deepBlue,
        paddingY: { xs: 0.5, sm: 2 },
        paddingX: { xs: 1.5, sm: 4 },
        marginTop: 'auto',
      })}
    >
      <Container
        maxWidth={false}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: { xs: 'center', sm: 'space-between' }, // Space between items on desktop
          alignItems: 'center', // Center items vertically
          gap: { xs: 1, sm: 0 }, // Gap between items
        }}
      >
        {/* "All rights reserved" Text */}
        <Typography
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: { xs: '0.6rem', sm: '1rem' },
            textAlign: { xs: 'center', sm: 'left' },
            marginTop: { xs: 0.5, sm: 0 },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          {t('footer.copyright')}
        </Typography>

        {/* Navigation Links */}
        <Box
          component="nav"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            gap: { xs: 1, sm: 4 },
            justifyContent: { xs: 'center', sm: 'flex-end' },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <Link
            href="/terms"
            aria-label="Navigate to Terms page"
            sx={theme => ({
              color: 'rgba(255, 255, 255, 0.85)',
              textDecoration: 'none',
              fontWeight: 500,
              transition: 'color 0.2s ease',
              '&:hover': {
                color: theme.colors.lavender,
              },
              fontSize: { xs: '0.75rem', sm: '1rem' },
            })}
          >
            {t('footer.terms')}
          </Link>
          <Link
            href="/privacy"
            aria-label="Navigate to Privacy page"
            sx={theme => ({
              color: 'rgba(255, 255, 255, 0.85)',
              textDecoration: 'none',
              fontWeight: 500,
              transition: 'color 0.2s ease',
              '&:hover': {
                color: theme.colors.lavender,
              },
              fontSize: { xs: '0.75rem', sm: '1rem' },
            })}
          >
            {t('footer.privacy')}
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
